import { visitsApi } from '@/api/resources'

/** Obrazovky navštívené v tomto načtení stránky — hlásíme každou jen jednou. */
const reported = new Set<string>()

/**
 * Ohlásí zobrazení obrazovky backendu. Volá se z router guardu, takže
 * nesmí nic vyhodit ani zdržovat navigaci — chybu jen spolkne.
 */
export function trackVisit(pageType: string, pageId = 0): void {
  const key = `${pageType}:${pageId}`
  if (reported.has(key)) return

  reported.add(key)
  void visitsApi.track(pageType, pageId).catch(() => {
    // Neúspěch znamená jen chybějící statistiku — zkusíme to při příští navigaci.
    reported.delete(key)
  })
}

/** Jen pro testy — vyprázdní paměť ohlášených obrazovek. */
export function resetVisitTracking(): void {
  reported.clear()
}
